import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const UsersIcon = createIcon({
  displayName: 'UsersIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M2,19v0c0,-2.209 1.791,-4 4,-4h4c2.209,0 4,1.791 4,4v0" />
        <path d="M10.4749,6.02513c1.36684,1.36684 1.36684,3.58291 0,4.94975c-1.36684,1.36684 -3.58291,1.36684 -4.94975,1.77636e-15c-1.36684,-1.36684 -1.36684,-3.58291 -8.88178e-16,-4.94975c1.36684,-1.36684 3.58291,-1.36684 4.94975,-8.88178e-16" />
        <path d="M16,14h3c1.657,0 3,1.343 3,3v0" />
        <path d="M19.2678,6.73223c0.976311,0.976311 0.976311,2.55922 0,3.53553c-0.976311,0.976311 -2.55922,0.976311 -3.53553,0c-0.976311,-0.976311 -0.976311,-2.55922 0,-3.53553c0.976311,-0.976311 2.55922,-0.976311 3.53553,0" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0,0h24v24h-24Z" />
    </>
  ),
})

const Users: FC<IconProps> = (props) => {
  return <CustomIcon as={UsersIcon} {...props} />
}

export default memo(Users)
